import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { PageBuilderTextareaModel } from '../page-builder-textarea.model';

@Component({
    selector: 'abw-page-builder-textarea-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => PageBuilderTextareaFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => PageBuilderTextareaFormComponent),
        multi: true
      }
    ],
    templateUrl: './page-builder-textarea-form.component.html',
    styleUrls: ['./page-builder-textarea-form.component.scss']
})
export class PageBuilderTextareaFormComponent implements ControlValueAccessor {
    @Input() model: PageBuilderTextareaModel;
    @Input() value: string;

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: string) {
        this.value = value; 
    }

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}

  onInputChanged(event: any) {
    this.value = event.target.value.replace(/\r?\n/g, '\n');
    console.log(this.value);
    this.propagateChange(event.target.value);
  }
}